import { FC, ReactNode } from 'react';
import { ContentTypeGuid } from '../types/enums';
import { ContentResponse } from '../types/shared';
import DocOchDocxFil from './DocOchDocxFil/DocOchDocxFil';
import PdfFil from './PdfFil/PdfFil';
import PptOchPptxFil from './PptOchPptxFil/PptOchPptxFil';
import XlsOchXlsxFil from './XlsOchXlsxFil/XlsOchXlsxFil';

interface IContentMediaProps {
  contentResponse: ContentResponse;
}

const ContentMedia: FC<IContentMediaProps> = ({ contentResponse }): ReactNode => {
  const renderContentMedia = () => {
    switch (contentResponse.contentTypeGuid) {
      case ContentTypeGuid.PdfFil:
        return <PdfFil contentResponse={contentResponse} />;
      case ContentTypeGuid.DocOchDocxFil:
        return <DocOchDocxFil contentResponse={contentResponse} />;
      case ContentTypeGuid.XlsOchXlsxFil:
        return <XlsOchXlsxFil contentResponse={contentResponse} />;
      case ContentTypeGuid.PptOchPptxFil:
        return <PptOchPptxFil contentResponse={contentResponse} />;
      default:
        console.log(`Renderingsimplementation saknas för Media med contentTypeGuid: ${contentResponse.contentTypeGuid}`);
        return <></>;
    }
  };

  return (
    <>
      {renderContentMedia()}
    </>
  );
};

export default ContentMedia;
